import { Alert, Typography, Box, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Snackbar } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import IAlert from "../../../types/Alert";
import { useNavigate } from "react-router-dom";
import * as constantes from "../../../common/Constantes";
import FacturacionService from "../../../services/FacturacionService";

const DetalleNoFacturable = ({ id, motivo, onUpdate }: { id: string, motivo?: string, onUpdate?: (newMotivo: string) => void }) => {
  const history = useNavigate();
  const [alert, setAlert] = useState<IAlert>({ open: false, severity: "info", msg: "" });
  const [open, setOpen] = useState(false);
  const [localMotivo, setLocalMotivo] = useState(motivo || "");
  const [loading, setLoading] = useState(false);

  const handleCloseAlert = () => setAlert({ open: false, severity: "info", msg: "" });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLocalMotivo(motivo || "");
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await FacturacionService.updateMotivoNoFacturable(id, localMotivo);
      setAlert({ open: true, severity: "success", msg: response.data.message});
      onUpdate?.(localMotivo);
      setOpen(false);
    } catch (e: any) {
      if (e.response.status === 401) {
        localStorage.clear();
        history(constantes.R_HOME);
      } else {
        setAlert({ open: true, severity: "error", msg: e.response?.data?.message || e.message });
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Box
      sx={{
        p: 1,
        mb: 1,
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        Esta cita está marcada como <b>NO facturable</b>
      </Typography>

      {motivo ? (
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Motivo:</strong> {motivo}
        </Typography>
      ) : (
        <Typography variant="body2" sx={{ mb: 1 }}>
          No se ha especificado motivo.
        </Typography>
      )}

      <Button
        size="small"
        variant="text"
        startIcon={<EditIcon fontSize="small" />}
        onClick={handleOpen}
        sx={{
          textTransform: "none",
          fontSize: "0.8rem",
          minWidth: "auto",
          px: 1,
          color: "text.secondary",
          "&:hover": {
            backgroundColor: "transparent",
            textDecoration: "underline",
          },
        }}
      >
       {!motivo ? "Añadir motivo" : "Editar motivo"}
      </Button>

      <Alert 
        severity="info"
        icon={<InfoIcon />}
        sx={{
          mt: 1,
          fontSize: "0.9rem",
          backgroundColor: "#f0f4ff",
          borderRadius: 1,
        }}
      >
        Puedes editar la cita para volver a marcarla como facturable.
      </Alert>

    </Box>

    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>{!motivo ? "Añadir motivo" : "Editar motivo"}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          label="Motivo no facturable"
          value={localMotivo}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => setLocalMotivo(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>

    <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
      <Alert variant="filled"  onClose={handleCloseAlert} severity={alert.severity} sx={{ width: "100%" }}>
        {alert.msg}
      </Alert>
    </Snackbar>
    </>
  );
};

export default DetalleNoFacturable;
